import React, { useState } from 'react'
import _ from 'lodash'
import { Box, FormControl, FormGroup, FormControlLabel, Switch } from '@material-ui/core'
import { TYPE } from './constant'
import { useStyles } from './style'

function SwitchButton(props) {
  const classes = useStyles()
  const [switchObj, setSwitchObj] = useState({
    production: true,
    consumption: true,
    importExport: true,
    battery: true
  })

  const handleChange = (e) => {
    let swap = _.cloneDeep(switchObj)
    switch (e.target.name) {
      case TYPE.PRODUCTION:
        swap['production'] = e.target.checked
        break
      case TYPE.CONSUMPTION:
        swap['consumption'] = e.target.checked
        break
      case TYPE.BATTERY:
        swap['battery'] = e.target.checked
        break
      default:
        swap['importExport'] = e.target.checked
        break
    }
    props.handleSwitch(swap)
    setSwitchObj(swap)
  }

  return (
    <Box className={classes.displaySwitch}>
      <FormControl className={classes.displaySwitch}>
        <FormGroup classes={{ root: classes.switchWrapper }}>
          <FormControlLabel
            control={
              <Switch className={`${classes.production} ${classes.switchLabel}`} checked={switchObj.production} onChange={handleChange} name={TYPE.PRODUCTION} />
            }
            label={TYPE.PRODUCTION}
          />
          <FormControlLabel
            control={
              <Switch className={`${classes.consumption} ${classes.switchLabel}`} checked={switchObj.consumption} onChange={handleChange} name={TYPE.CONSUMPTION} />
            }
            label={TYPE.CONSUMPTION}
          />
          <FormControlLabel
            control={
              <Switch className={`${classes.importExport} ${classes.switchLabel}`} checked={switchObj.importExport} onChange={handleChange} name={TYPE.IMPORT_EXPORT} />
            }
            label={TYPE.IMPORT_EXPORT}
          />
          <FormControlLabel
            control={
              <Switch className={`${classes.battery} ${classes.switchLabel}`} checked={switchObj.battery} onChange={handleChange} name={TYPE.BATTERY} />
            }
            label={TYPE.BATTERY}
          />
        </FormGroup>
      </FormControl>
    </Box>
  )
}

export default SwitchButton